import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroller";
import {
  Card,
  Tag,
  Typography,
  Row,
  Col,
  Avatar,
  Space,
  Button,
  Dropdown,
  Empty,
} from "antd";
import {
  MessageOutlined,
  PhoneOutlined,
  FileTextOutlined,
  CalendarOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFileInvoice,
//   faEnvelopeCircleCheck,
//   faFile,
//   faClock,
//   faPhoneAlt,
//   faBuilding,
// } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getLeadActivitiesByDateAPI } from "../LeadsAPI";
import dayjs from "dayjs";
import { resetActivitiesByDate } from "../LeadsSlice";
import { getEmployeeAPI } from "CommonComponents/Lookup/LookupAPI";
import { FormattedMessage } from "react-intl";

function ActivitiesTab() {
  const { Text } = Typography;
  const dispatch = useDispatch();
  const { leadId } = useParams();
  const leadActivities = useSelector((state) => state.leads.activitiesByDate);
  const employeeList = useSelector((state) => state.lookup.employesList);
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    dispatch(resetActivitiesByDate());
    setPageNo(1);
    setHasMore(true);
    dispatch(getEmployeeAPI());
  }, [leadId]);

  const values = {
    pageNo: pageNo,
    pageSize: 10,
    searchQuery: "",
  };
  const loadMoreData = (page) => {
    const currentPage = page || pageNo;
    if (loading || !hasMore) return;
    setLoading(true);

    dispatch(getLeadActivitiesByDateAPI(leadId, values))
      .then((res) => {
        const items = res?.payload?.items || [];
        const totalPages = res?.payload?.totalPages;
        const currentPage = res?.payload?.pageNumber;

        if (currentPage >= totalPages || items.length === 0) {
          setHasMore(false);
        } else {
          setPageNo(currentPage + 1);
        }
      })
      .finally(() => setLoading(false));
  };

  const getEmployeeNameById = (employeeId) => {
    const employee = employeeList?.find((item) => item?.id === employeeId);
    return employee
      ? `${employee.firstName} ${employee.lastName}`
      : "Unknown User";
  };
  const getActivityIcon = (type) => {
    switch (type) {
      case "Email":
        return {
          icon: <MessageOutlined style={{ color: "#624af2" }} />,
          color: "#f0ebff",
        };
      case "Call":
        return {
          icon: <PhoneOutlined style={{ color: "#09979e" }} />,
          color: "#e1fafa",
        };
      case "Note":
        return {
          icon: <FileTextOutlined style={{ color: "#ffa500" }} />,
          color: "#fff6e6",
        };
      default:
        return { icon: <FileTextOutlined />, color: "#f0f0f0" };
    }
  };

  // const items = [
  //   {
  //     label: (
  //       <a rel="noopener noreferrer">
  //         <FontAwesomeIcon icon={faFileInvoice} /> Notes
  //       </a>
  //     ),
  //     key: "0",
  //   },
  //   {
  //     label: (
  //       <a rel="noopener noreferrer">
  //         <FontAwesomeIcon icon={faPhoneAlt} />
  //         &nbsp;{<FormattedMessage id="Leads.Calls" />}
  //       </a>
  //     ),
  //     key: "1",
  //   },
  //   {
  //     label: (
  //       <a rel="noopener noreferrer">
  //         <FontAwesomeIcon icon={faFile} />
  //         &nbsp;{<FormattedMessage id="Leads.Files" />}
  //       </a>
  //     ),
  //     key: "2",
  //   },
  //   {
  //     label: (
  //       <a rel="noopener noreferrer">
  //         <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
  //         &nbsp;{<FormattedMessage id="Leads.Emails" />}
  //       </a>
  //     ),
  //     key: "3",
  //   },
  // ];

  return (
    <>
      <div style={{ maxHeight: "60vh", overflow: "auto" }}>
        <InfiniteScroll
          pageStart={1}
          loadMore={loadMoreData}
          hasMore={hasMore && !loading}
          useWindow={false}
          threshold={100}
          loader={
            <div key="loader" style={{ textAlign: "center", padding: "10px" }}>
              {<FormattedMessage id="Common.loading" />}
            </div>
          }
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {leadActivities.length > 0 ? (
              leadActivities.map((entry, index) => (
                <div key={index}>
                  <Tag
                    icon={<CalendarOutlined />}
                    color="purple"
                    className="mb-10"
                  >
                    {dayjs(entry.date).format("DD MMM YYYY")}
                  </Tag>

                  {entry.activities.map((activity) => {
                    const { icon, color } = getActivityIcon(activity.type);
                    return (
                      <Card
                        key={activity.id}
                        size="small"
                        className="activitytab mb-10"
                      >
                        <Space align="start">
                          <div style={{ width: 32 }}>
                            <Avatar
                              shape="square"
                              size={28}
                              icon={icon}
                              style={{
                                background: color,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            />
                            <div>
                              <Text type="secondary" className="f-11">
                                {activity.time}
                              </Text>
                            </div>
                          </div>
                          <div>
                            <Text strong>
                              {getEmployeeNameById(activity.createdBy)}{" "}
                              {activity.type === "Call" ? (
                                <>
                                  <FormattedMessage id="LeadActivity.CallsDesc" />
                                  {activity.followUpDate && (
                                    <>
                                      {" "}
                                      <FormattedMessage id="LeadActivity.FollowUpCalls" />{" "}
                                      {dayjs(activity.followUpDate).format(
                                        "YYYY-MM-DD"
                                      )}
                                      .
                                    </>
                                  )}
                                </>
                              ) : activity.type === "Note" ? (
                                <FormattedMessage id="LeadActivity.NotesDesc" />
                              ) : activity.type === "Email" ? (
                                <FormattedMessage id="LeadActivity.EmailDesc" />
                              ) : (
                                ""
                              )}
                            </Text>

                            {activity.description && (
                              <div style={{ marginTop: 4 }}>
                                <Text>{activity.description}</Text>
                              </div>
                            )}
                          </div>
                        </Space>
                      </Card>
                    );
                  })}
                </div>
              ))
            ) : (
              <Card className="text-center">
                <Empty description={false} />
                <Text type="secondary">{<FormattedMessage id="NoData" />}</Text>
              </Card>
            )}

            {!hasMore && leadActivities?.length > 0 && (
              <div
                style={{
                  textAlign: "center",
                  padding: "1rem",
                  color: "#999",
                }}
              >
                {<FormattedMessage id="Common.EndOfList" />}
              </div>
            )}
          </Space>
        </InfiniteScroll>
      </div>
    </>
  );
}

export default ActivitiesTab;
